export class GAEvents {
  static readonly ROUTE_CHANGE = 'route_change';
  static readonly EDIT_SDK = 'edit_sdk';
  static readonly EDIT_DAPP = 'edit_dapp';
  static readonly CREATE_DAPP = 'create_dapp';
  static readonly CREATE_MULTI_SIG = 'create_multi_sig';
  static readonly CREATE_STABLECOIN = 'create_stablecoin';
}
